import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const exportHrReportSlice = createSlice({
  name: "exportHrReport",
  initialState,
  reducers: {
    exportHrReportStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    exportHrReportSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    exportHrReportFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  exportHrReportStart,
  exportHrReportSuccess,
  exportHrReportFailed,
} = exportHrReportSlice.actions;

export default exportHrReportSlice.reducer;
